import { gql } from '@apollo/client';

const GET_SAML_RESPONSE_BODY = gql`
  query($userId: String!, $year: Float!, $agentId: String) {
    getSAMLResponseBody(user_id: $userId, year: $year, agent_id: $agentId) {
      response_body
    }
  }
`;

export default GET_SAML_RESPONSE_BODY;
